<template>
    <div class="h-100">

         <div class="h-100">
                  <div v-if="agencyDet!=null" class="h-100">
                    <div class="h-100">
                      <div class="card-w-shadow-row" >

                         <CRow v-if="agencyDet.b2bcode">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/agent_code.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <strong>{{$t('cAgentDetail.agntCode')}}</strong>
                            </CCol>
                            <CCol>{{agencyDet.b2bcode}}</CCol>
                          </div>
                        </CRow>


                        <CRow v-if="agencyDet.agencyname">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/Agency_Name.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <strong>{{$t('cAgentDetail.agencyName')}}</strong>
                            </CCol>
                            <CCol>{{agencyDet.agencyname}}</CCol>
                          </div>
                        </CRow>

                        <CRow v-if="agencyDet.business_regno">
                          <div class="approve-f-icon">
                            <img
                              src="@imgPath/img/svg/icons/Buisness_Registration_Number.svg"
                              alt
                            />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{$t('cAgentDetail.busRegNo')}}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div>{{agencyDet.business_regno}}</div>
                            </CCol>
                          </div>
                        </CRow>
                        <CRow v-if="agencyDet.iatanumber">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/IATA_Number.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{$t('cAgentDetail.iataNo')}}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div>{{agencyDet.iatanumber}}</div>
                            </CCol>
                          </div>
                        </CRow>

                        <CRow v-if="agencyDet.contact_name">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/name.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{$t('cAgentDetail.agtName')}}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div>{{agencyDet.contact_name}}</div>
                            </CCol>
                          </div>
                        </CRow>
                        <CRow v-if="agencyDet.contact_address">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/Address.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{$t('cAgentDetail.agtAdrs')}}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div>{{agencyDet.contact_address}}</div>
                            </CCol>
                          </div>
                        </CRow>
                        <CRow v-if="agencyDet.contact_city">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/City.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{$t('cAgentDetail.agtCity')}}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div>{{agencyDet.contact_city}}</div>
                            </CCol>
                          </div>
                        </CRow>
                        <CRow v-if="agencyDet.contact_state_name">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/State.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{$t('cAgentDetail.agtState')}}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div>{{agencyDet.contact_state_name}}</div>
                            </CCol>
                          </div>
                        </CRow>
                        <CRow v-if="agencyDet.contact_postalcode">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/postal_code.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{$t('cAgentDetail.agtPostal')}}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div>{{agencyDet.contact_postalcode}}</div>
                            </CCol>
                          </div>
                        </CRow>
                        <CRow v-if="agencyDet.emailid">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/Contact_Email_ID.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{$t('cAgentDetail.emailName')}}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div>{{agencyDet.emailid}}</div>
                            </CCol>
                          </div>
                        </CRow>
                        <CRow v-if="agencyDet.mobile_number">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/name.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{$t('cAgentDetail.agtNo')}}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div class="d-flex">
                                <div>{{agencyDet.mobile_code}}</div>
                                <div>{{ agencyDet.mobile_number}}</div>
                              </div>
                            </CCol>
                          </div>
                        </CRow>
                         <CRow v-if="agencyDet.agenttype">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/blue-icons/mobileNumber.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{$t('cAgentDetail.agencyType')}}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div class="d-flex">
                                <div>{{agencyDet.agenttype==1?$t('cAgentDetail.prepaid'):$t('cAgentDetail.postpaid')}}</div>
                              
                              </div>
                            </CCol>
                          </div>
                        </CRow>
                         <CRow v-if="agencyDet.postpaidtype">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/agent_code.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{ $t("manage.postpaidType") }}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div class="d-flex">
                                 <div v-if="agencyDet.postpaidtype==postpaidType.weekly">{{ $t("manage.weekly")
                                    }}
                                </div>
                                <div v-else-if="agencyDet.postpaidtype==postpaidType.onceAWeek">{{
                                    $t("manage.onceAWeek") }}
                                </div>
                                <div v-else-if="agencyDet.postpaidtype==postpaidType.monthly">{{
                                    $t("manage.monthly") }}
                                </div>
                              
                              </div>
                            </CCol>
                          </div>
                        </CRow>
                         <CRow v-if="agencyDet.schedule && agencyDet.schedule.scheduleid">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/blue-icons/Payment_Schedule.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{ $t("manage.payScheduleType") }}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div class="d-flex">
                                <div> {{ $t("manage.schedule") + ' ' + agencyDet.schedule.scheduleid}}</div>
                              
                              </div>
                            </CCol>
                          </div>
                        </CRow>
                         <CRow v-if="agencyDet.creditlimit_type">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/blue-icons/creditlimit.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{ $t("manage.creditLimit") }}</strong>
                              </div>
                            </CCol>
                            <CCol>
                              <div class="d-flex">
                                <div v-if="agencyDet.creditlimit_type==1">{{ $t("manage.fixed")
                                    }}
                                </div>
                                <div v-else-if="agencyDet.creditlimit_type==2">{{
                                   agencyDet.postpaidtype==postpaidType.weekly ? 
                                    $t("manage.repWeekly") : agencyDet.postpaidtype==postpaidType.onceAWeek ?
                                    $t("manage.repTwice"): $t("manage.repMonthly")}}
                                </div>
                              
                              </div>
                            </CCol>
                          </div>
                        </CRow>
                       
                      <div class="card-w-shadow-row h-30 mt-30px assign-tiers-card" v-if="isNeedAssTier">
                        <div class="d-flex mb-25px">
                          <CCol class="d-flex">
                            <span class="title">
                            {{$t('cAgentDetail.assignedTiers')}}
                            </span>
                             <span >

                        </span>


                          </CCol>
                          <CCol class="d-flex overflow-unset">
                            <button type="button" @click="navToAddNewPricing" class="btn-primary">{{agencyDet.tiers&&agencyDet.tiers.length>0?$t('cAgentDetail.editBtn'):$t('cAgentDetail.addBtn')}}</button>
                            <cHelpTip :content="$t('helpTip.cAgtDtlAssTier')"></cHelpTip>
                          </CCol>
                        </div>
                        <div class="card-l-line" v-for="(tierObj,index) in agencyDet.tiers" :key="index">
                          <div class="approve-f-icon">
                            <img src="@imgPath/img/svg/icons/blue-icons/tier.svg" alt />
                          </div>
                          <div class="subtitile-details">
                            <CCol>
                              <div>
                                <strong>{{tierObj.tier.name}}</strong>
                              </div>
                              <div class="d-flex mt-5px">
                                <div class="f-bold">
                                 <span class="c-b-dull">
                               {{$t('cAgentDetail.ticketingDate')}}
                               </span>
                                  {{tierObj.fromDate|formatDate}}

                                  <span class="c-b-dull">
                                 {{$t('cAgentDetail.to')}}
                                 </span>
                                  {{tierObj.toDate|formatDate}}
                                </div>
                          
                              </div>
                            </CCol>
                         
                          </div>
                        </div>

                      </div>

                    </div>
                  
                  </div>
                  
                </div>
                 

 </div>
    </div>
</template>

<script>
    import { mapActions} from "vuex";

    import apiGetAssignedTiers from "./../../services/apiGetAssignedTiers";

import {handleJWT, getErrorAlertValue
    } from "../../util/util";
    import router, {navigate} from "./../../router/index";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "../../util/apiValidate";
import SERVICE_URL, {
        FILE_NAME,
        LOG_TYPE,
    } from "./../../config/API_DATA";
import { COMPONENT_NAME, PATHNAME, POSTPAID_TYPE } from "../../util/constants";
import BaseConfiguration from "../../config/base.js";
import Logger from "./../../services/logger";
import cHelpTip from "./../../components/cHelpTip"
export default {
    name: COMPONENT_NAME.C_AGENT_DETAILS,

    components: {
      cHelpTip
    },

    props: {
        agencyDet : {
            type: Object|Array,
            default : null
        },
        isNeedAssTier:{
           type: Boolean,
            default : false

        },
        isNeedAgencyType:{
        type: Boolean,
            default : false
        }
    },
      data: () => ({
           
      }),

    data() {
      return {
       
        postpaidType: {
                    weekly: POSTPAID_TYPE.WEEKLY,
                    onceAWeek: POSTPAID_TYPE.ONCE_A_WEEK,
                    monthly: POSTPAID_TYPE.MONTHLY
                },
      }
    },

    methods:{
        ...mapActions("sAssignPricing", ["SET_SELECTED_TIER"]),
                    ...mapActions("sAssignPricing", ["SET_SELECTED_PRICING"]),

      async navToAddNewPricing() {
          try {
            if(BaseConfiguration.isDebug) console.log("navToAddNewPricing");
            if(this.agencyDet&&this.agencyDet.b2bid){
              await this.getAssignedTiers(this.agencyDet.b2bid);

            }
            let selectedPricingObj={
              agencyCode:this.agencyDet.b2bcode,
              agentName:this.agencyDet.agencyname,
              b2bId:this.agencyDet.b2bid,
              pricing:this.agencyDet.tiers
              
            }
             this.SET_SELECTED_PRICING(selectedPricingObj);

           navigate(
                        PATHNAME.ADD_NEW_PRICING
                    );
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.C_AGENT_DETAILS,
                    "error in navToAddNewPricing",
                    err.toString(),
                    "navToAddNewPricing",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
          }, 
              async getAssignedTiers(pB2bid) {
                let returnValue;

                try {
                    let assignedTierRequest = apiGetAssignedTiers.buildRequest(pB2bid);
                    if (assignedTierRequest) {
                        let assignedTierResponse = await apiGetAssignedTiers.getResponse(
                            assignedTierRequest
                        );

                        if (VALIDATE_SUCCESS_RES(assignedTierResponse)) {
                            returnValue = assignedTierResponse.data.data;
                            this.SET_SELECTED_TIER(returnValue);
                            // this.showAlert(null);
                        } else {
                            let error = getErrorMessage(assignedTierResponse);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid request";
                    }

                    return returnValue;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_AGENT_DETAILS,
                        "error in getAssignedTiers",
                        err.toString(),
                        "getAssignedTiers",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

    }

}
</script>